module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_01.3417b452.gif";